import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { PARTNERS_LOGOS } from 'hb-builder/components/UIComponents/page/block/Partners/Partner/constants';
import PartnerUI from 'hb-builder/components/UIComponents/page/block/Partners/Partner/PartnerUI';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { PartnersItem } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';
import { Col } from 'hb-react/shared/components/DesignSystem/Grid';

const Partner: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<PartnersItem>) => {
  const { subdomainNetworkUrl } = useRendererContext();
  const { columnWidth, logoBackground, openInNewTab, partnerImage } =
    item?.attributes || {};
  const { partnerImageAlt, partnerImageUrl } = item || {};

  return (
    <Col width={columnWidth}>
      <PartnerUI
        index={(item?.index || 0) % PARTNERS_LOGOS.length}
        logoBackground={logoBackground}
        openInNewTab={openInNewTab}
        padding={{ _: 3, m: 4 }}
        partnerImage={partnerImage}
        partnerImageAlt={partnerImageAlt}
        partnerImageUrl={partnerImageUrl}
        subdomainNetworkUrl={subdomainNetworkUrl}
      />
    </Col>
  );
};

Partner.componentName = 'Partner';
Partner.Render = Render;

Partner.item = ({
  columnWidth,
  index,
  logoBackground,
  openInNewTab = true,
  partnersCount,
  partnerImage = '',
  partnerImageAlt = '',
  partnerImageUrl = '',
  template,
}) => ({
  type: Partner.componentName,
  attributes: {
    columnWidth,
    logoBackground,
    openInNewTab,
    partnerImage,
  },
  index,
  partnersCount,
  partnerImageAlt,
  partnerImageUrl,
  template,
});

export default Partner;
